import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=2dd7e5ce&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports